<template>
    <CRow>
        <CCol>
            <CCard class="mb-4">
                <CCardHeader>
                    <strong>Стол заказов: интервалы доставки</strong>
                    <ShopCatalogTabLinks class="mt-2" />
                </CCardHeader>
                <CCardBody>
                    <p class="text-muted">
                        У блюда можно отметить несколько интервалов.
                        Если не отмечен ни один, блюдо доступно в любое время.
                        «Приём до» — время в день доставки, после которого слот закрывается.
                    </p>
                    <div
                        v-for="interval in intervals"
                        :key="interval.id"
                        class="form-inline mb-2"
                    >
                        <input
                            v-model="intervalDrafts[interval.id].start"
                            type="time"
                            class="form-control mr-2"
                            @change="syncIntervalLabel(interval.id)"
                        >
                        <input
                            v-model="intervalDrafts[interval.id].end"
                            type="time"
                            class="form-control mr-2"
                            @change="syncIntervalLabel(interval.id)"
                        >
                        <input
                            v-model="intervalDrafts[interval.id].deadline"
                            type="time"
                            class="form-control mr-2"
                            title="Приём заказа до"
                        >
                        <input
                            v-model="intervalDrafts[interval.id].label"
                            class="form-control mr-2"
                            placeholder="Подпись"
                        >
                        <CButton
                            color="primary"
                            class="mr-2"
                            @click="saveInterval(interval.id)"
                        >
                            Сохранить
                        </CButton>
                        <CButton
                            color="danger"
                            variant="outline"
                            @click="removeInterval(interval.id)"
                        >
                            Удалить
                        </CButton>
                    </div>
                    <div class="form-inline mt-3">
                        <input v-model="newInterval.start" type="time" class="form-control mr-2" @change="syncNewIntervalLabel">
                        <input v-model="newInterval.end" type="time" class="form-control mr-2" @change="syncNewIntervalLabel">
                        <input v-model="newInterval.deadline" type="time" class="form-control mr-2" title="Приём заказа до">
                        <input v-model="newInterval.label" class="form-control mr-2" placeholder="Подпись">
                        <CButton color="primary" @click="addInterval">Добавить</CButton>
                    </div>
                </CCardBody>
            </CCard>

            <CCard class="mb-4">
                <CCardHeader>
                    <strong>Категории стола заказов</strong>
                </CCardHeader>
                <CCardBody>
                    <p class="text-muted">
                        Предустановленные категории витрины. Подкатегории блюд
                        показываются в приложении чипсами внутри родительской категории.
                    </p>
                    <div class="form-inline mb-3">
                        <input
                            v-model="newCategoryTitle"
                            class="form-control mr-2"
                            placeholder="Новая категория"
                            @keyup.enter="addCategory"
                        >
                        <CButton color="primary" @click="addCategory">Добавить категорию</CButton>
                    </div>
                    <div
                        v-for="category in categories"
                        :key="category.id"
                        class="border rounded p-3 mb-3"
                    >
                        <div class="form-inline mb-2">
                            <input
                                v-model="categoryDrafts[category.id]"
                                class="form-control mr-3 mb-3"
                            >
                            <input
                                v-model="leadDrafts[category.id]"
                                type="number"
                                min="1"
                                max="336"
                                class="form-control mr-3 mb-3"
                                placeholder="Приём за, ч"
                                title="За сколько часов до слота принимать заказ. Пусто — сроки слотов. Кейтеринг — 24."
                            >
                            <input
                                type="file"
                                accept="image/*"
                                class="form-control-file mr-2"
                                @change="uploadCategoryPicture(category.id, $event)"
                            >
                            <img
                                v-if="pictureDrafts[category.id]"
                                :src="pictureUrl(pictureDrafts[category.id])"
                                alt=""
                                class="mr-2 ml-2"
                                style="height: 48px; width: 48px; object-fit: cover;"
                            >
                            <CButton
                                v-if="pictureDrafts[category.id]"
                                color="secondary"
                                class="mr-2"
                                @click="clearCategoryPicture(category.id)"
                            >
                                Убрать картинку
                            </CButton>
                        </div>
                        <div class="mt-2">
                            <span
                                v-for="subcategory in category.subcategories"
                                :key="subcategory.id"
                                class="badge badge-light border mr-2 mb-2 p-2"
                            >
                                {{ subcategory.title }}
                                <button
                                    type="button"
                                    class="btn btn-link btn-sm p-0 ml-2"
                                    @click="removeSubcategory(subcategory.id)"
                                >
                                    удалить
                                </button>
                            </span>
                            <span v-if="!category.subcategories.length" class="text-muted">
                                Подкатегорий нет
                            </span>
                        </div>
                        <div class="form-inline mt-2">
                            <input
                                v-model="newTitles[category.id]"
                                class="form-control mr-2"
                                placeholder="Новая подкатегория"
                                @keyup.enter="addSubcategory(category.id)"
                            >
                            <CButton
                                color="primary"
                                @click="addSubcategory(category.id)"
                            >
                                Добавить
                            </CButton>
                        </div>
                        <div class="mt-3">
                            <CButton
                                color="primary"
                                class="mr-2"
                                @click="saveCategory(category.id)"
                            >
                                Сохранить
                            </CButton>
                            <CButton
                                color="danger"
                                variant="outline"
                                @click="removeCategory(category.id)"
                            >
                                Удалить
                            </CButton>
                        </div>
                    </div>
                </CCardBody>
            </CCard>

            <CCard>
                <CCardHeader>
                    <strong>Теги iiko для сайта</strong>
                </CCardHeader>
                <CCardBody>
                    <p class="text-muted">
                        При интеграции стола заказов теги блюда из iiko сопоставляются
                        с интервалом доставки или подкатегорией.
                    </p>
                    <div
                        v-for="tag in iikoTags"
                        :key="tag.id"
                        class="border rounded p-3 mb-3"
                    >
                        <div class="form-inline mb-2">
                            <input
                                v-model="tagDrafts[tag.id].tag"
                                class="form-control mr-2"
                                placeholder="Тег из iiko"
                            >
                            <select
                                v-model="tagDrafts[tag.id].kind"
                                class="form-control mr-2"
                                @change="tagDrafts[tag.id].targetId = ''"
                            >
                                <option value="interval">Интервал</option>
                                <option value="subcategory">Подкатегория</option>
                            </select>
                            <select
                                v-if="tagDrafts[tag.id].kind === 'interval'"
                                v-model="tagDrafts[tag.id].targetId"
                                class="form-control mr-2"
                            >
                                <option value="">Выберите интервал</option>
                                <option
                                    v-for="interval in intervals"
                                    :key="interval.id"
                                    :value="interval.id"
                                >
                                    {{ interval.label }}
                                </option>
                            </select>
                            <select
                                v-else
                                v-model="tagDrafts[tag.id].targetId"
                                class="form-control mr-2"
                            >
                                <option value="">Выберите подкатегорию</option>
                                <option
                                    v-for="subcategory in subcategoryOptions"
                                    :key="subcategory.id"
                                    :value="subcategory.id"
                                >
                                    {{ subcategory.label }}
                                </option>
                            </select>
                            <CButton
                                color="primary"
                                class="mr-2"
                                @click="saveIikoTag(tag.id)"
                            >
                                Сохранить
                            </CButton>
                            <CButton
                                color="danger"
                                variant="outline"
                                @click="removeIikoTag(tag.id)"
                            >
                                Удалить
                            </CButton>
                        </div>
                    </div>
                    <div class="form-inline">
                        <input
                            v-model="newIikoTag.tag"
                            class="form-control mr-2"
                            placeholder="Новый тег из iiko"
                        >
                        <select
                            v-model="newIikoTag.kind"
                            class="form-control mr-2"
                            @change="newIikoTag.targetId = ''"
                        >
                            <option value="interval">Интервал</option>
                            <option value="subcategory">Подкатегория</option>
                        </select>
                        <select
                            v-if="newIikoTag.kind === 'interval'"
                            v-model="newIikoTag.targetId"
                            class="form-control mr-2"
                        >
                            <option value="">Выберите интервал</option>
                            <option
                                v-for="interval in intervals"
                                :key="'new-' + interval.id"
                                :value="interval.id"
                            >
                                {{ interval.label }}
                            </option>
                        </select>
                        <select
                            v-else
                            v-model="newIikoTag.targetId"
                            class="form-control mr-2"
                        >
                            <option value="">Выберите подкатегорию</option>
                            <option
                                v-for="subcategory in subcategoryOptions"
                                :key="'new-' + subcategory.id"
                                :value="subcategory.id"
                            >
                                {{ subcategory.label }}
                            </option>
                        </select>
                        <CButton color="primary" @click="addIikoTag">
                            Добавить
                        </CButton>
                    </div>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
import Vue from 'vue';
import ShopCatalogTabLinks from '@/components/ShopCatalogTabLinks';

export default {
    name: 'ShopCatalogSettings',

    components: {
        ShopCatalogTabLinks
    },

    data() {
        return {
            intervals: [],
            categories: [],
            newTitles: {},
            intervalDrafts: {},
            categoryDrafts: {},
            pictureDrafts: {},
            newInterval: { start: '', end: '', deadline: '', label: '' },
            leadDrafts: {},
            newCategoryTitle: '',
            iikoTags: [],
            tagDrafts: {},
            newIikoTag: { tag: '', kind: 'interval', targetId: '' }
        };
    },

    computed: {
        subcategoryOptions() {
            const options = [];
            for (const category of this.categories) {
                for (const subcategory of category.subcategories || []) {
                    options.push({
                        id: subcategory.id,
                        label: `${category.title} — ${subcategory.title}`
                    });
                }
            }
            return options;
        }
    },

    mounted() {
        this.loadCatalog();
    },

    methods: {
        loadCatalog() {
            return Vue.axios.get('/shop-catalog')
                .then(({ data }) => {
                    this.intervals = data.intervals || [];
                    this.categories = data.categories || [];
                    this.iikoTags = data.iiko_tags || [];
                    this.intervalDrafts = {};
                    this.categoryDrafts = {};
                    this.leadDrafts = {};
                    this.pictureDrafts = {};
                    this.tagDrafts = {};
                    for (const tag of this.iikoTags) {
                        this.$set(this.tagDrafts, tag.id, {
                            tag: tag.tag,
                            kind: tag.shop_subcategory_id ? 'subcategory' : 'interval',
                            targetId: tag.shop_subcategory_id || tag.shop_delivery_interval_id || ''
                        });
                    }
                    for (const interval of this.intervals) {
                        this.$set(this.intervalDrafts, interval.id, {
                            start: this.minutesToInput(interval.start_minutes),
                            end: this.minutesToInput(interval.end_minutes),
                            deadline: interval.order_deadline_minutes == null
                                ? ''
                                : this.minutesToInput(interval.order_deadline_minutes),
                            label: interval.label
                        });
                    }
                    for (const category of this.categories) {
                        this.$set(this.categoryDrafts, category.id, category.title);
                        this.$set(
                            this.leadDrafts,
                            category.id,
                            category.order_lead_hours || ''
                        );
                        this.$set(this.pictureDrafts, category.id, category.picture || '');
                        if (this.newTitles[category.id] == null) {
                            this.$set(this.newTitles, category.id, '');
                        }
                    }
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Не удалось загрузить каталог');
                });
        },

        minutesToInput(minutes) {
            const hours = Math.floor(minutes / 60);
            const mins = minutes % 60;
            return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
        },

        formatLabel(start, end) {
            if (!start || !end) return '';
            const [sh, sm] = start.split(':');
            const [eh, em] = end.split(':');
            return `${Number(sh)}:${sm}-${Number(eh)}:${em}`;
        },

        syncIntervalLabel(id) {
            const draft = this.intervalDrafts[id];
            if (!draft) return;
            draft.label = this.formatLabel(draft.start, draft.end);
        },

        syncNewIntervalLabel() {
            this.newInterval.label = this.formatLabel(this.newInterval.start, this.newInterval.end);
        },

        saveInterval(id) {
            const draft = this.intervalDrafts[id];
            Vue.axios.put(`/shop-catalog/intervals/${id}`, draft)
                .then(() => this.loadCatalog())
                .catch(err => {
                    this.$root.$emit('showError', err.response?.data?.error || 'Не удалось сохранить интервал');
                });
        },

        addInterval() {
            Vue.axios.post('/shop-catalog/intervals', this.newInterval)
                .then(() => {
                    this.newInterval = { start: '', end: '', deadline: '', label: '' };
                    return this.loadCatalog();
                })
                .catch(err => {
                    this.$root.$emit('showError', err.response?.data?.error || 'Не удалось добавить интервал');
                });
        },

        removeInterval(id) {
            if (!window.confirm('Удалить интервал?')) return;
            Vue.axios.delete(`/shop-catalog/intervals/${id}`)
                .then(() => this.loadCatalog())
                .catch(err => {
                    this.$root.$emit('showError', err.response?.data?.error || 'Не удалось удалить интервал');
                });
        },

        pictureUrl(value) {
            if (!value) return '';
            if (/^(https?:|data:|blob:)/i.test(value)) return value;
            const base = (process.env.VUE_APP_STATIC_BASE_URL || '').replace(/\/$/, '');
            return base ? `${base}/${String(value).replace(/^\//, '')}` : `/${String(value).replace(/^\//, '')}`;
        },

        uploadCategoryPicture(id, event) {
            const file = event.target.files && event.target.files[0];
            if (!file) return;
            const formData = new FormData();
            formData.append('file', file);
            Vue.axios.post('/files/upload', formData)
                .then(({ data }) => {
                    this.$set(this.pictureDrafts, id, data.filename);
                    return this.saveCategory(id);
                })
                .catch(err => {
                    this.$root.$emit('showError', err.response?.data?.error || 'Не удалось загрузить картинку');
                });
        },

        clearCategoryPicture(id) {
            this.$set(this.pictureDrafts, id, '');
            this.saveCategory(id);
        },

        saveCategory(id) {
            const title = (this.categoryDrafts[id] || '').trim();
            Vue.axios.put(`/shop-catalog/categories/${id}`, {
                title,
                picture: this.pictureDrafts[id] || null,
                order_lead_hours: this.leadDrafts[id] || null
            })
                .then(() => this.loadCatalog())
                .catch(err => {
                    this.$root.$emit('showError', err.response?.data?.error || 'Не удалось сохранить категорию');
                });
        },

        addCategory() {
            const title = this.newCategoryTitle.trim();
            if (!title) return;
            Vue.axios.post('/shop-catalog/categories', { title })
                .then(() => {
                    this.newCategoryTitle = '';
                    return this.loadCatalog();
                })
                .catch(err => {
                    this.$root.$emit('showError', err.response?.data?.error || 'Не удалось добавить категорию');
                });
        },

        removeCategory(id) {
            if (!window.confirm('Удалить категорию? Подкатегории и соответствия iiko для неё тоже пропадут.')) return;
            Vue.axios.delete(`/shop-catalog/categories/${id}`)
                .then(() => this.loadCatalog())
                .catch(err => {
                    this.$root.$emit('showError', err.response?.data?.error || 'Не удалось удалить категорию');
                });
        },

        addSubcategory(categoryId) {
            const title = (this.newTitles[categoryId] || '').trim();
            if (!title) return;

            Vue.axios.post(`/shop-catalog/categories/${categoryId}/subcategories`, { title })
                .then(() => {
                    this.$set(this.newTitles, categoryId, '');
                    return this.loadCatalog();
                })
                .catch(err => {
                    this.$root.$emit('showError', err.response?.data?.error || 'Не удалось создать подкатегорию');
                });
        },

        removeSubcategory(id) {
            Vue.axios.delete(`/shop-catalog/subcategories/${id}`)
                .then(() => this.loadCatalog())
                .catch(err => {
                    this.$root.$emit('showError', err.response?.data?.error || 'Не удалось удалить подкатегорию');
                });
        },

        iikoTagPayload(draft) {
            return {
                tag: (draft.tag || '').trim(),
                interval_id: draft.kind === 'interval' ? draft.targetId : null,
                subcategory_id: draft.kind === 'subcategory' ? draft.targetId : null
            };
        },

        addIikoTag() {
            Vue.axios.post('/shop-catalog/iiko-tags', this.iikoTagPayload(this.newIikoTag))
                .then(() => {
                    this.newIikoTag = { tag: '', kind: 'interval', targetId: '' };
                    return this.loadCatalog();
                })
                .catch(err => {
                    this.$root.$emit('showError', err.response?.data?.error || 'Не удалось сохранить тег');
                });
        },

        saveIikoTag(id) {
            const draft = this.tagDrafts[id];
            Vue.axios.put(`/shop-catalog/iiko-tags/${id}`, this.iikoTagPayload(draft))
                .then(() => this.loadCatalog())
                .catch(err => {
                    this.$root.$emit('showError', err.response?.data?.error || 'Не удалось сохранить тег');
                });
        },

        removeIikoTag(id) {
            if (!window.confirm('Удалить соответствие тега?')) return;
            Vue.axios.delete(`/shop-catalog/iiko-tags/${id}`)
                .then(() => this.loadCatalog())
                .catch(err => {
                    this.$root.$emit('showError', err.response?.data?.error || 'Не удалось удалить тег');
                });
        }
    }
};
</script>
